export default __webpack_public_path__ + "static/immersiveLearning-da3f625870efae70d3d4b34f79a3a874.png";